import type { PayType } from "../types";

export const HOURLY_FRACTION_DIGITS = 2;
export const SALARY_FRACTION_DIGITS = 0;
export const HOURLY_COMPENSATION_INCREMENT = "0.01";
export const SALARY_COMPENSATION_INCREMENT = "1";

export function getCompensationFractionDigits(payType?: PayType) {
  return payType === "SALARY" ? SALARY_FRACTION_DIGITS : HOURLY_FRACTION_DIGITS;
}

export function getCompensationInputConfig(payType: PayType) {
  const compensationIncrement =
    payType === "SALARY" ? SALARY_COMPENSATION_INCREMENT : HOURLY_COMPENSATION_INCREMENT;
  const fractionDigits = getCompensationFractionDigits(payType);

  return {
    min: compensationIncrement,
    step: compensationIncrement,
    precision: fractionDigits,
    numberFormatOptions: {
      style: "decimal",
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    } satisfies Intl.NumberFormatOptions,
  };
}
